import posthog from 'posthog-js';
import { ADOBE_EXCHANGE_URL } from '../constants/urls';

/**
 * Marketing-site proxy for “install from Exchange”.
 * We cannot measure the Adobe Exchange install itself — this is intent.
 */
export function captureInstallIntent(source: string, extra: Record<string, unknown> = {}) {
  posthog.capture('install_clicked', {
    source,
    funnel_step: 'install_intent',
    ...extra,
  });
}

/** Track install intent, then open Adobe Exchange in a new tab. */
export function openAdobeExchange(
  source: string,
  extra: Record<string, unknown> = {}
) {
  captureInstallIntent(source, extra);
  window.open(ADOBE_EXCHANGE_URL, '_blank', 'noopener,noreferrer');
}
